import Vue from 'vue'
import Vuex from 'vuex'
import core from '@centit/module-core/src/store/modules/core'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    core,
  },
})
